import { useState } from "react";
import "./Presurvey.css";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as solidStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";
const Presurvey = ({
  setPreSurvey,
  setTermsAndConditionCheck,
  setFormData,
}) => {
  const [form, setForm] = useState({
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s6: "",
  });
  const [selectedOptions, setSelectedOptions] = useState([]);

  const options = [
    { id: "s5op-1", label: "Pediatrician", value: "Pediatrician" },
    { id: "s5op-2", label: "Books", value: "Books" },
    { id: "s5op-3", label: "Websites", value: "Websites" },
    { id: "s5op-4", label: "Apps", value: "Apps" },
    { id: "s5op-5", label: "Friends", value: "Friends" },
    { id: "s5op-6", label: "None", value: "None" },
  ];

  const S1options = [1, 2, 3, 4, 5];
  const S2options = [
    { id: "s2op-1", label: "Never", value: "never", name: "s2" },
    { id: "s2op-2", label: "1-2 Times", value: "1-2", name: "s2" },
    { id: "s2op-3", label: "Weekly", value: "weekly", name: "s2" },
    { id: "s2op-4", label: "Daily", value: "daily", name: "s2" },
  ];

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    console.log("checked ", checked);
    setSelectedOptions(
      (prev) =>
        checked
          ? [...prev, value] // add on check
          : prev.filter((val) => val !== value) // remove on uncheck
    );
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
  const getCommaSeparated = () => selectedOptions.join(", ");
  const optionlength = selectedOptions.length > 0;

  function handleSubmit(e) {
    e.preventDefault();
    const validateFields = Object.values({
      // s1: form.s1,
      // s2: form.s2,
      s3: form.s3,
      // s4: form.s4,
      s5: optionlength ? getCommaSeparated() : "",
      s6: form.s6,
    }).every((val) => val);
    if (!validateFields) {
      toast.warn("Please answer all questions");
      return;
    }
    setFormData((prev) => ({
      ...prev,
      s1: form.s1,
      s2: form.s2,
      s3: form.s3,
      s4: form.s4,
      s5: optionlength ? getCommaSeparated() : "",
      s6: form.s6,
    }));

    setPreSurvey(false);
  }
  return (
    <form className="presurvey" onSubmit={handleSubmit}>
      <p>Baseline-Survey</p>
      <div className="survey-container">
      <p>Please complete below and click continue Sign-up</p>
        {/* <div className="survey-questiondiv">
          <label htmlFor="s1">1. Stress level monitoring development</label>
          <div className="star-rating">
            {S1options.map((val) => (
              <span
                key={val}
                onClick={() =>
                  handleChange({
                    target: { name: "s1", value: val.toString() },
                  })
                }
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon
                  icon={form.s1 >= val ? solidStar : regularStar}
                  style={{
                    color: "#f5b301",
                    fontSize: "24px",
                    marginRight: "4px",
                  }}
                />
              </span>
            ))}
          </div>
        </div>
        <div className="survey-questiondiv">
          <label htmlFor="s2">
            2. Frequency of checking milestones last month
          </label>
          <div className="survey-options">
            {S2options.map((opt) => (
              <div key={opt.id} className="survey-option">
                <label htmlFor={opt.id}>
                  <input
                    type="radio"
                    id={opt.id}
                    name={opt.name}
                    value={opt.value}
                    checked={form.s2 === opt.value}
                    onChange={handleChange}
                  />
                  {opt.label}
                </label>
              </div>
            ))}
          </div>
        </div> */}

        <div className="survey-questiondiv">
          <label htmlFor="s3">1. I have a good understanding of my child’s developmental milestones.</label>
          <div className="star-rating">
            {S1options.map((val) => (
              <span
                key={val}
                onClick={() =>
                  handleChange({
                    target: { name: "s3", value: val.toString() },
                  })
                }
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon
                  icon={form.s3 >= val ? solidStar : regularStar}
                  style={{
                    color: "#f5b301",
                    fontSize: "24px",
                    marginRight: "4px",
                  }}
                />
              </span>
            ))}
          </div>
        </div>
        {/* <div className="survey-questiondiv">
          <label htmlFor="s4">. Confidence in next steps if delay</label>
          <div className="star-rating">
            {S1options.map((val) => (
              <span
                key={val}
                onClick={() =>
                  handleChange({
                    target: { name: "s4", value: val.toString() },
                  })
                }
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon
                  icon={form.s4 >= val ? solidStar : regularStar}
                  style={{
                    color: "#f5b301",
                    fontSize: "24px",
                    marginRight: "4px",
                  }}
                />
              </span>
            ))}
          </div>
        </div> */}
        <div className="survey-questiondiv">
          <label htmlFor="s5">2. Sources I rely on for developmental milestone information (choose all that apply)</label>
          <div className="survey-options">
            {options.map((opt) => (
              <div key={opt.id} className="survey-option">
                <label htmlFor={opt.id}>
                  <input
                    type="checkbox"
                    id={opt.id}
                    name="options"
                    value={opt.value}
                    checked={selectedOptions.includes(opt.value)}
                    onChange={handleCheckboxChange}
                  />
                  {opt.label}
                </label>
              </div>
            ))}
          </div>
        </div>
        <div className="survey-questiondiv survey-s6">
          <label htmlFor="s6">3. My biggest worry about my child is</label>
          <textarea name="s6" id="s6" onChange={handleChange}></textarea>
        </div>
      <div className="survey-btns">
        <button type="submit">Continue Sign-up</button>
        <button
          type="button"
          onClick={() => {
            setPreSurvey(false);
            setTermsAndConditionCheck(false);
          }}
        >
          cancel
        </button>
      </div>
      </div>
    </form>
  );
};
export default Presurvey;
